// extracted by mini-css-extract-plugin
module.exports = {"item":"Registration_item__1ouFa","navLinkActive":"Registration_navLinkActive__3QCdg"};